/**************************************************
 * Nombre:       Tarjeta_Cuentas_Documento_Requerido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {DownloadOutlined} from "@mui/icons-material";
import {descargarArchivo} from "../../Utilidades/descargarArchivo";

const Tarjeta_Cuentas_Documento_Requerido = ({item, index, click}) => {

    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 1, cursor: 'pointer'}}
        >


            <Grid container size={2} sx={{justifyContent: 'flex-start'}}>
                <IconButton
                    onClick={() => descargarArchivo(item.recurso, `${item.nombre}.${item.tipo === "Pdf" ? 'pdf' : 'png'}`)}>
                    <DownloadOutlined/>
                </IconButton>
            </Grid>

            <Grid container size={10} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    onClick={() => click(item, index)}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                >
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600}}>{item.tipo}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                        <Typography sx={{fontSize: 14}}>{item.nombre}</Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Cuentas_Documento_Requerido